import type { ActiveLangKey } from "./lang.ts";
import type { LangKey } from './lang.ts';
export const MIRROR_FILE_WRITE_COPY = {
  "pt": {
    "review": "Revise a operação no arquivo antes de confirmar. Ainda não foi salvo.",
    "blocked": "Este pedido de arquivo exige uma única operação explícita no app VYV.",
    "created": "Arquivo criado e verificado no {{provider}}.",
    "appended": "Texto acrescentado e verificado no {{provider}}.",
    "uploaded": "Arquivo enviado e verificado no {{provider}}."
  },
  "en": {
    "review": "Review the file operation before confirming. It has not been saved yet.",
    "blocked": "This file request requires one explicit operation in the VYV app.",
    "created": "File created and verified in {{provider}}.",
    "appended": "Text appended and verified in {{provider}}.",
    "uploaded": "File uploaded and verified in {{provider}}."
  },
  "nl": {
    "review": "Controleer de bestandsbewerking voordat je bevestigt. Er is nog niets opgeslagen.",
    "blocked": "Dit bestandsverzoek vereist één expliciete bewerking in de VYV-app.",
    "created": "Bestand aangemaakt en gecontroleerd in {{provider}}.",
    "appended": "Tekst toegevoegd en gecontroleerd in {{provider}}.",
    "uploaded": "Bestand geüpload en gecontroleerd in {{provider}}."
  },
  "es": {
    "review": "Revisa la operación del archivo antes de confirmar. Todavía no se ha guardado.",
    "blocked": "Esta solicitud de archivo requiere una única operación explícita en la app VYV.",
    "created": "Archivo creado y verificado en {{provider}}.",
    "appended": "Texto añadido y verificado en {{provider}}.",
    "uploaded": "Archivo subido y verificado en {{provider}}."
  },
  "fr": {
    "review": "Vérifiez l’opération sur le fichier avant de confirmer. Rien n’a encore été enregistré.",
    "blocked": "Cette demande de fichier exige une seule opération explicite dans l’app VYV.",
    "created": "Fichier créé et vérifié dans {{provider}}.",
    "appended": "Texte ajouté et vérifié dans {{provider}}.",
    "uploaded": "Fichier envoyé et vérifié dans {{provider}}."
  },
  "it": {
    "review": "Rivedi l’operazione sul file prima di confermare. Non è stato ancora salvato.",
    "blocked": "Questa richiesta di file richiede una singola operazione esplicita nell’app VYV.",
    "created": "File creato e verificato in {{provider}}.",
    "appended": "Testo aggiunto e verificato in {{provider}}.",
    "uploaded": "File caricato e verificato in {{provider}}."
  },
  "de": {
    "review": "Prüfe den Dateivorgang vor der Bestätigung. Es wurde noch nichts gespeichert.",
    "blocked": "Diese Dateianfrage erfordert einen einzelnen ausdrücklichen Vorgang in der VYV-App.",
    "created": "Datei in {{provider}} erstellt und überprüft.",
    "appended": "Text in {{provider}} angehängt und überprüft.",
    "uploaded": "Datei in {{provider}} hochgeladen und überprüft."
  },
  "pl": {
    "review": "Sprawdź operację na pliku przed potwierdzeniem. Nic nie zostało jeszcze zapisane.",
    "blocked": "To żądanie dotyczące pliku wymaga jednej wyraźnej operacji w aplikacji VYV.",
    "created": "Plik utworzony i sprawdzony w {{provider}}.",
    "appended": "Tekst dopisany i sprawdzony w {{provider}}.",
    "uploaded": "Plik przesłany i sprawdzony w {{provider}}."
  }
} as const satisfies Record<ActiveLangKey, { "review": string; "blocked": string; "created": string; "appended": string; "uploaded": string }>;
/** BG is frozen; unsupported copy uses the explicit English fallback. */
export const mirrorFileWriteCopy=(lang:LangKey)=>MIRROR_FILE_WRITE_COPY[lang==='bg'?'en':lang];
